module.exports = __webpack_public_path__ + "assets/img/b19f8454af06e4ca9c33d5c5b36f61b4.png";